import React from 'react';
import { PropertyFlag as SrsPropertyFlag, DILProperty } from 'srs-middleware';
import { FacetPreview } from '/views/filterHub/facet/facetPreview';
import { FacetPanel } from '../views/filterHub/facet/facetPanel';
import { HierarchicalFacetPreview } from 'views/filterHub/hierarchicalFacet/hierarchicalFacetPreview';
import { HierarchicalFacetPanel } from 'views/filterHub/hierarchicalFacet/hierarchicalFacetPanel';

const FILTER_COMPONENTS = {
  HIERARCHICAL_FACET: 'HIERARCHICAL FACET',
  FACET: 'FACET'
}

/**
 * Determines which Component will render for each of the different filtering properties
 */
export function useFilters(properties: DILProperty[] = [], config = {}) {

  const getComponentKey = (property: DILProperty, component: string): string => {
    if (component) {
      return component;
    }
    else if (property.flags.includes(SrsPropertyFlag.Hierarchical)) {
      return FILTER_COMPONENTS.HIERARCHICAL_FACET;
    }
    else if (property.flags.includes(SrsPropertyFlag.Categorical)) {
      return FILTER_COMPONENTS.FACET;
    }
  }

  const renderComponents = properties.map((property) => {
    const componentKey: string = getComponentKey(property, config[property.name]);
    if (componentKey === FILTER_COMPONENTS.HIERARCHICAL_FACET)
    {
      return ({
        property: property,
        component: (openNewPanel,
          toggleCollapse: boolean,
          isOpen: boolean,
          key: boolean) => 
          <HierarchicalFacetPreview 
            key={key}
            property={property} 
            openNewPanel={() => openNewPanel && openNewPanel(property, HierarchicalFacetPanel)}
            toggleCollapse={toggleCollapse}
            isOpen={isOpen}
          />
      })
    }
    else if (componentKey === FILTER_COMPONENTS.FACET) {
      return ({
        property: property,
        component: (openNewPanel,
          toggleCollapse: boolean,
          isOpen: boolean,
          key: boolean) => 
          <FacetPreview
            key={key}
            property={property} 
						openNewPanel={() => openNewPanel && openNewPanel(property, FacetPanel)}
            toggleCollapse={toggleCollapse}
            isOpen={isOpen}
          />
      })
    }
    else {
      return null;
    }
  }).filter(x => x !== null);

  return {renderComponents};
}
